import { datepicker } from '@chenfengyuan/datepicker'

class DateRange {
  constructor (el) {
    this.el = el
    this.start = this.el.querySelector('.js-date-range-start')
    this.end = this.el.querySelector('.js-date-range-end')
    this.startContainer = this.el.querySelector('.js-date-range-start-container')
    this.endContainer = this.el.querySelector('.js-date-range-end-container')
    this.lang = this.el.getAttribute('data-lang')

    console.log(this.lang)

    this.initDefaults()
  }

  initDefaults () {
    this.initPicker()
    this.initEvents()
  }

  initEvents () {
    this.startContainer.addEventListener('click', e => this.openStartPicker())
    this.endContainer.addEventListener('click', e => this.openEndPicker())
    document.addEventListener('click', e => this.clickOut(e))
  }

  clickOut (e) {
    const $target = $(e.target)
    if ( !$(this.startContainer).is(e.target) && $(this.startContainer).has(e.target).length === 0 ) {
      this.startContainer.classList.remove('active')
    }
    if ( !$(this.endContainer).is(e.target) && $(this.endContainer).has(e.target).length === 0 ) {
      this.endContainer.classList.remove('active')
    }
  }

  openStartPicker () {
    this.endContainer.classList.remove('active')
    this.startContainer.classList.add('active')
  }

  openEndPicker () {
    this.startContainer.classList.remove('active')
    this.endContainer.classList.add('active')
  }

  initPicker () {

    $.fn.datepicker.languages['uk-UA'] = {
      format: 'dd.mm.YYYY',
      days: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П\'ятниця', 'Субота'],
      daysShort: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      daysMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      months: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
      monthsShort: ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
      weekStart: 1,
      startView: 0,
      yearFirst: false,
      yearSuffix: ''
    };

    $(this.start).datepicker({
      autoHide: true,
      format: 'dd.mm.yyyy',
      weekStart: 1,
      language: this.lang,
      inline: true,
      container: '.js-date-range-start-container',
      trigger: '.js-date-range-start'
    })

    $(this.end).datepicker({
      autoHide: true,
      format: 'dd.mm.yyyy',
      weekStart: 1,
      language: this.lang,
      inline: true,
      startDate: $(this.start).datepicker('getDate'),
      container: '.js-date-range-end-container',
      trigger: '.js-date-range-end'
    });

    $(this.start).on('change', () => {
      $(this.end).datepicker('setStartDate', $(this.start).datepicker('getDate'));
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.js-date-range')

  if (el) {
    new DateRange(el)
  }
})